if (!window.AppLoaded) {
    require('bootstrap');
    require('./stimulus');
    require('./turbo');
    window.AppLoaded = true;
}
